import { render, staticRenderFns } from "./RightCenter.vue?vue&type=template&id=57654100&scoped=true"
import script from "./RightCenter.vue?vue&type=script&lang=js"
export * from "./RightCenter.vue?vue&type=script&lang=js"
import style0 from "./RightCenter.vue?vue&type=style&index=0&id=57654100&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57654100",
  null
  
)

export default component.exports